// Central error classification for the offline / degraded-network path.
// Anything that looks like "server is temporarily unreachable" should be silenced
// from toasts + Sentry and routed through the NetworkStatus store instead.

export function isNetworkError(err: unknown): boolean {
  if (err instanceof TypeError) return true; // fetch "Failed to fetch"
  if (err instanceof Error && err.name === 'AbortError') return true;
  const status = extractStatus(err);
  return status === 0 || status === 502 || status === 503 || status === 504;
}

export function extractStatus(err: unknown): number | undefined {
  if (typeof err === 'object' && err !== null && 'status' in err) {
    const s = (err as { status: unknown }).status;
    if (typeof s === 'number') return s;
  }
  if (err instanceof Error) {
    const match = err.message.match(/\b(50[234]|0)\b/);
    if (match) return Number(match[1]);
  }
  return undefined;
}
